<template>
  <a-modal
    title="SPI订阅管理"
    centered
    :width="1200"
    :mask-closable="false"
    :visible="showForm"
    :footer="null"
    @cancel="close"
  >
    <div class="spi-subscription">
      <div class="spi-subscription-header">
        <a-space>
          <span>授权账号: {{ record.name }} (ID: {{ record.id }})</span>
          <span>广告主数量: {{ advertisers.length }}</span>
        </a-space>
      </div>

      <a-divider />

      <div class="spi-subscription-warning">
        <a-alert type="error" show-icon>
          <span slot="message" style="color: #f5222d; font-weight: 500;">
            快手订阅任务中的关联应用一定要与当前授权账号保持一致
          </span>
        </a-alert>
      </div>

      <div class="spi-subscription-config">
        <a-form layout="inline">
          <a-form-item label="订阅任务ID">
            <a-input-number v-model="subscribeTaskId" placeholder="请输入订阅任务ID" style="width: 200px" />
          </a-form-item>
          <a-form-item>
            <a-button type="primary" :loading="subscribeAllLoading" :disabled="!subscribeTaskId" @click="handleSubscribeAll">
              一键订阅全部
            </a-button>
          </a-form-item>
          <a-form-item>
            <a-button :loading="queryLoading" :disabled="!subscribeTaskId" @click="querySubscription">
              同步订阅状态
            </a-button>
          </a-form-item>
          <a-form-item>
            <a-button danger :loading="unsubscribeLoading" :disabled="checkedKeys.length === 0 || !subscribeTaskId" @click="handleBatchUnsubscribe">
              批量取消订阅 ({{ checkedKeys.length }})
            </a-button>
          </a-form-item>
        </a-form>
      </div>

      <a-divider />

      <vxe-grid
        ref="xTable"
        border
        resizable
        show-overflow
        highlight-hover-row
        :loading="tableGrid.loading"
        :data="tableGrid.data"
        :columns="tableGrid.columns"
        :pager-config="tableGrid.pagerConfig"
        @page-change="handlePageChange"
        @checkbox-change="handleSelectChange"
        @checkbox-all="handleSelectAll"
        height="400"
      >
        <template #state="{ row }">
          <a-tag :color="row.state === 1 ? 'green' : 'red'">
            {{ row.state === 1 ? '生效' : '失效' }}
          </a-tag>
        </template>
        <template #action="{ row }">
          <a-space>
            <a href="javascript:;" @click="handleResubscribe(row)" v-if="row.state !== 1">重新订阅</a>
            <a href="javascript:;" @click="handleSingleUnsubscribe(row)" v-if="row.state === 1">取消订阅</a>
          </a-space>
        </template>
      </vxe-grid>

      <div v-if="resultMessage" class="spi-subscription-result">
        <a-alert :type="resultType" :message="resultMessage" show-icon closable @close="resultMessage = ''" />
      </div>
    </div>
  </a-modal>
</template>

<style lang="less" scoped>
.spi-subscription {
  .spi-subscription-header {
    margin-bottom: 8px;
  }
  .spi-subscription-warning {
    margin-bottom: 16px;
  }
  .spi-subscription-config {
    margin-bottom: 8px;
  }
  .spi-subscription-result {
    margin-top: 16px;
  }
}
</style>

<script>
import SpiSubscription from './SpiSubscription'

export default SpiSubscription
</script>
